import React from 'react';
import { Link } from 'react-router-dom';

export default function LogoMenuBar() {
  return (
    <Link to={'/'}>
      <img src="/images/logos/SpaDigital_Vetor.png" alt="Spa Digital logo" style={{ width: '260px' }} />
    </Link>
  );
}
